export const SCROLLBAR_WIDTH = 10;
export const SMALL_SCROLLBAR_WIDTH = 6;
export const DRAWER_WIDTH_OPEN = 280;
export const DRAWER_WIDTH_CLOSE = 52;
export const VIEWER_DRAWER_WIDTH_OPEN = 280;
export { default as drawer } from './drawer';
